import { CustomerState } from '../state';

export const updateCustomerConvertedReducer = (state: CustomerState) => {
  state.converted = false;
};
